import { observable, makeObservable, action, runInAction } from 'mobx';
import { cloneDeep } from 'lodash';
import { strIsEmpty } from '../utils/tools';

import ToastUtils from '../utils/ToastUtils';

// ---
import {
    handlePersonalInfo,
    handleArchivesRecordList,
    handleDeclarationDetail,
    handleDeclarationFormList,
    handleDeclarationCategoryList,
    handleAddDeclarationInfo,
    handleEditDeclarationInfo,
    handleUserInfo,
    handleDeclarationArchives,
    handleDeclarationCategoryAllList
} from '../api/declaration';
const handleClassField = (data, valueMap) => {
        let temData = cloneDeep(data);
        temData.forEach((ele) => {
            if (ele.en_name === 'org_id') {
                //这个预置字段 需要单独处理下
                ele.en_name = 'org_name';
                ele.field_type = 7;
            }
            //增加value字段
            if (valueMap) {
                ele.value = valueMap[ele.en_name];
                if (
                    ele.field_type === 4 &&
                    (ele.setting['data_source'] === 'province_city_district' ||
                        ele.setting['data_source'] === 'province_city' ||
                        ele.setting['data_source'] === 'province') &&
                    valueMap[ele.en_name]?.length
                ) {
                    ele['value_source'] = valueMap?.[ele.en_name + '_name'] ? valueMap[ele.en_name + '_name'] : [];
                }
            }
        });
        return temData.sort((a, b) => a.sort - b.sort);
    },
    class_map = new Map([
        [1, '基本信息'],
        [2, '联系方式'],
        [4, '学习经历'],
        [3, '工作信息'],
        [5, '党员档案'],
        [6, '账号信息']
    ]),
    mapToOptions = (map, rename = { label: 'label', value: 'value' }) => {
        let res = [];
        map.forEach((value, key) => {
            res.push({
                [rename.label]: value,
                [rename.value]: key
            });
        });
        return res;
    },
    //获取字段分类
    //后端返回的数据格式{1:[],2:[]}
    //前端筛选返回的分类，并排序
    //使用 mapToOptions做循环主要是保证顺序，Object.keys 不能保证顺序
    getClassItem = (data) => {
        const keys = Object.keys(data).map((ele) => Number(ele)); //将后端返回的keys取出
        return mapToOptions(class_map).filter((ele) => keys.includes(ele.value));
    },
    //处理分类字段
    //后端返回的数据格式{1:[...],2:[...]}
    //处理成[{{label:'基本信息',value:1,children:[...]}},{{label:'联系方式',value:2,children:[...]}}]
    handleClassesField = (data, valueMap = null) => {
        let temData = cloneDeep(data),
            classData = getClassItem(temData); //获取分类
        classData.forEach((ele) => {
            ele.children = handleClassField(temData[ele.value], valueMap);
        });

        return classData;
    };
class Declaration {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        formatPersonalInfo: [],
        archivesRecordList: [],
        declarationCategoryList: [],
        userInfo: [],
        isLoadingSave: false,
        isLoadingSub: false
    };

    @action
    setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };

    //获取学员信息 学时学分
    getPersonalInfo = () => {
        handlePersonalInfo().then((res) => {
            if (res.data) {
                let formatData = handleClassesField(res.data?.field_key, res.data?.field_value);
                this.setState({
                    formatPersonalInfo: formatData
                });
            }
        });
    };
    // 类型
    @observable
    declarationFormType = '';
    @action
    setDeclarationFormType = (data) => {
        this.declarationFormType = data;
    };
    // 学习档案 学时学分
    @observable
    archivesRecordList = '';

    @action
    getArchivesRecordList = (data) => {
        handleArchivesRecordList(data).then((res) => {
            if (res.data) {
                this.setState({
                    archivesRecordList: res.data
                });
            }
        });
    };

    // 类型
    @observable
    declarationCategory = '';
    @action
    setDeclarationCategory = (data) => {
        this.declarationCategory = data;
    };

    // 表单
    @observable
    declarationFormList = [];
    @action
    setDeclarationFormList = async (data) => {
        if (this.declarationFormType === 'archives' || this.declarationFormType === 'detail') {
            await this.getDeclarationCategoryAllList();
        } else {
            await this.getDeclarationCategoryList();
        }

        // recognized_credits 认定学分
        // recognized_period 认定学时
        // category_id 类别id

        let all = [],
            category = this.state.declarationCategoryList.filter((item) => item.id === this.declarationCategory),
            categoryItem = [
                {
                    name: '类别',
                    value: category[0].name,
                    en_name: 'category_name',
                    desc: '1',
                    field_type: 1,
                    required: 1,
                    updated: 0,
                    setting: {
                        type: 'text',
                        maxLength: 100
                    }
                }
            ],
            end = [
                {
                    name: '认定学时',
                    value: null,
                    en_name: 'recognized_period',
                    desc: '',
                    field_type: 3,
                    required: 0,
                    updated: 0,
                    setting: {
                        type: 'text',
                        maxLength: 5,
                        number_range: [0.01, 99.99]
                    }
                },
                {
                    name: '认定学分',
                    value: null,
                    en_name: 'recognized_credits',
                    desc: '',
                    field_type: 3,
                    required: 0,
                    updated: 0,
                    setting: {
                        type: 'text',
                        maxLength: 5,
                        number_range: [0.01, 99.99]
                    }
                }
            ],
            detail = [
                {
                    name: '申请时间',
                    value: null,
                    en_name: 'submit_time',
                    desc: '',
                    field_type: 5,
                    required: 1,
                    updated: 0,
                    setting: {
                        type: 'text',
                        showTime: true
                    }
                }
            ],
            archives = [
                {
                    name: '来源',
                    value: null,
                    en_name: 'source',
                    desc: '',
                    field_type: 2,
                    required: 1,
                    updated: 0,
                    setting: {
                        options: [
                            {
                                can_delete: false,
                                name: '组织录入',
                                id: 0,
                                enabled: true
                            },
                            {
                                can_delete: false,
                                name: '组织认定',
                                id: 1,
                                enabled: true
                            },
                            {
                                can_delete: false,
                                name: '自主申报',
                                id: 2,
                                enabled: true
                            },
                            {
                                can_delete: false,
                                name: '智慧平台',
                                id: 3,
                                enabled: true
                            }
                        ],
                        data_source_type: 1,
                        type: 'single'
                    }
                },
                {
                    name: '生成时间',
                    value: null,
                    en_name: 'generation_time',
                    desc: '',
                    field_type: 5,
                    required: 1,
                    updated: 0,
                    setting: {
                        type: 'text',
                        showTime: true
                    }
                }
            ],
            plan = [
                {
                    name: '培训计划',
                    en_name: 'training_plan_name',
                    required: 1,
                    setting: {
                        type: 'text',
                        maxLength: 100
                    }
                },
                {
                    name: '培训类型',
                    en_name: 'training_type_name',
                    required: 0,
                    setting: {
                        type: 'text',
                        maxLength: 100
                    }
                }
            ];
        if (this.declarationFormType === 'detail' || this.declarationFormType === 'archives') {
            categoryItem = categoryItem.concat(plan);
        }
        // 学时学分锁定  0 开 1 关 返回0  学时，学分不可编辑
        if (data.field_value?.fixed_claim_enabled === 0) {
            end.map((v) => (v.updated = 1));
        }
        // 处理顶部不可编辑项
        all = categoryItem.concat(data.field_key, end);

        // 处理详情时的申请时间
        if (this.declarationFormType === 'detail') {
            if (data.field_value['state'] === 0) {
                detail[0]['field_type'] = '1';
                data.field_value['submit_time'] = '-';
            }

            all = all.concat(detail);
        }
        if (this.declarationFormType === 'archives') {
            all = all.concat(archives);
        }
        all.map((v, i) => {
            if (i > 0)
                v.value =
                    data.field_value[v.en_name] === '' || data.field_value[v.en_name] === null || data.field_value[v.en_name] === undefined
                        ? null
                        : data.field_value[v.en_name];
        });

        this.declarationFormList = all;
    };
    @action
    getDeclarationFormList = () => {
        handleDeclarationFormList(this.declarationCategory).then((res) => {
            // res.data = [];
            if (res.data) {
                this.setDeclarationFormList(res.data);
            }
        });
    };
    @action
    getDeclarationDetail = async (id) => {
        await handleDeclarationDetail(id).then((res) => {
            // res.data = [];
            if (res.data) {
                this.setDeclarationFormList(res.data);
            }
        });
    };

    @action
    getDeclarationArchives = async (id) => {
        this.declarationFormList = [];
        await handleDeclarationArchives(id).then((res) => {
            if (res.data) {
                this.setDeclarationFormList(res.data);
            }
        });
    };

    @action
    getDeclarationCategoryList = async () => {
        await handleDeclarationCategoryList().then((res) => {
            if (res.success && res.data) {
                this.setState({
                    declarationCategoryList: res.data
                });
            }
        });
    };

    @action
    getDeclarationCategoryAllList = async () => {
        await handleDeclarationCategoryAllList().then((res) => {
            if (res.success && res.data) {
                this.setState({
                    declarationCategoryList: res.data
                });
            }
        });
    };

    addDeclarationInfo = async (baseInfo = {}) => {
        let data = {},
            toastMsg = '';
        runInAction(() => {
            this.declarationFormList?.find((item) => {
                let value = item.value;
                if (strIsEmpty(value)) {
                    item.value = '';
                    if (item.required === 0) {
                        toastMsg = `${item.name}不能为空`;
                        // ToastUtils.showToast(toastMsg);
                        ToastUtils.showToast('请完善信息');
                        return true;
                    }
                } else {
                    let setting = item.setting,
                        type = setting.type;
                    if (type === 'text' || type === 'textarea') {
                        let maxLength = setting.maxLength;
                        if (maxLength) {
                            let value = item.value;
                            if (value.length > maxLength) {
                                toastMsg = `${item.name}最多输入${maxLength}个字符`;
                                ToastUtils.showToast(toastMsg);
                                return true;
                            }
                        }
                    }
                }

                data[item.en_name] = item.value;

                return false;
            });
        });
        data = Object.assign({}, baseInfo, data);

        // return { code: '00000', msg: '报名异常' };
        if (baseInfo.state === 0 || baseInfo.state === '0') {
            this.setState({ isLoadingSave: true });
        } else {
            this.setState({ isLoadingSub: true });
        }
        if (strIsEmpty(toastMsg)) {
            try {
                const { code, msg } = await handleAddDeclarationInfo(data);
                this.setState({ isLoadingSave: false });
                this.setState({ isLoadingSub: false });
                this.declarationFormList = [];
                return { code: code, msg: msg };
            } catch (e) {
                // ToastUtils.showToast(e.message);
                this.setState({ isLoadingSave: false });
                this.setState({ isLoadingSub: false });
                return { code: '-2', msg: '填报异常' }; //false
                // return false;
            }
        } else {
            this.setState({ isLoadingSave: false });
            this.setState({ isLoadingSub: false });
            return { code: '-1', msg: '信息填写有误' }; //false
            // return false;
        }
    };
    editDeclarationInfo = async (baseInfo = {}) => {
        let data = {},
            toastMsg = '';
        runInAction(() => {
            this.declarationFormList?.find((item) => {
                let value = item.value;
                if (strIsEmpty(value)) {
                    item.value = '';
                    if (item.required === 0) {
                        toastMsg = `${item.name}不能为空`;
                        // ToastUtils.showToast(toastMsg);
                        ToastUtils.showToast('请完善信息');
                        return true;
                    }
                } else {
                    let setting = item.setting,
                        type = setting.type;
                    if (type === 'text' || type === 'textarea') {
                        let maxLength = setting.maxLength;
                        if (maxLength) {
                            let value = item.value;
                            if (value.length > maxLength) {
                                toastMsg = `${item.name}最多输入${maxLength}个字符`;
                                ToastUtils.showToast(toastMsg);
                                return true;
                            }
                        }
                    }
                }

                data[item.en_name] = item.value;

                return false;
            });
        });
        data = Object.assign({}, baseInfo, data);

        // return { code: '00000', msg: '报名异常' };

        if (strIsEmpty(toastMsg)) {
            try {
                const { code, msg } = await handleEditDeclarationInfo(data);
                return { code: code, msg: msg };
            } catch (e) {
                // ToastUtils.showToast(e.message);
                return { code: '-2', msg: '填报异常' }; //false
                // return false;
            }
        } else {
            return { code: '-1', msg: '信息填写有误' }; //false
            // return false;
        }
    };

    // 学习档案 学时学分
    @observable
    userInfo = '';

    @action
    getUserInfo = () => {
        handleUserInfo().then((res) => {
            if (res.data) {
                this.setState({
                    userInfo: res.data
                });
            }
        });
    };
}
export default new Declaration();
